(function () {
  'use strict';

  // ---- formatMoney: matches Shopify's money_format token expansion ----
  function formatMoney(cents, format) {
    if (!format) format = '${{amount}}';
    var value = cents / 100;
    function fmt(num, precision, thousands, decimal) {
      if (isNaN(num) || num == null) return '0';
      precision = precision != null ? precision : 2;
      thousands = thousands || ',';
      decimal = decimal || '.';
      var parts = num.toFixed(precision).split('.');
      var int = parts[0].replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
      var dec = parts[1] ? decimal + parts[1] : '';
      return int + dec;
    }
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, fmt(value, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, fmt(value, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fmt(value, 2, '.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, fmt(value, 0, '.', ','))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, fmt(value, 2, "'", '.'));
  }

  // ---- Parse a rendered price string ("$322.99", "€289,99 EUR", "£249") to cents ----
  function parsePriceString(str) {
    if (!str) return null;
    // Strip currency, keep digits + first decimal/thousands separator
    var raw = str.replace(/[^\d.,-]/g, '').trim();
    if (!raw) return null;
    // Grouping-only price ("1,234" / "1.234.567"): groups of exactly 3 digits
    // and a single separator kind — e.g. zero-decimal currencies or
    // amount_no_decimals money formats. Treat separators as thousands.
    if (/^\d{1,3}([.,]\d{3})+$/.test(raw)) {
      return parseInt(raw.replace(/[.,]/g, ''), 10) * 100;
    }
    // Determine which is the decimal separator by position of last . vs ,
    var lastDot = raw.lastIndexOf('.');
    var lastComma = raw.lastIndexOf(',');
    var decimal;
    if (lastDot === -1 && lastComma === -1) {
      // No separator → integer dollars
      return parseInt(raw, 10) * 100;
    } else if (lastDot > lastComma) {
      decimal = '.';
      raw = raw.replace(/,/g, '');
    } else {
      decimal = ',';
      raw = raw.replace(/\./g, '').replace(',', '.');
    }
    var num = parseFloat(raw);
    if (isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function updateRoot(root, priceCents) {
    if (priceCents == null) return;
    var target = root.querySelector('[data-per-month-value]');
    if (!target) return;
    var months = parseInt(root.getAttribute('data-months'), 10) || 6;
    var format = root.getAttribute('data-money-format');
    var perMonth = Math.round(priceCents / months);
    target.textContent = formatMoney(perMonth, format);
  }

  function updateAll(priceCents, productId) {
    if (priceCents == null) return;
    document.querySelectorAll('[data-chiputt-per-month]').forEach(function (root) {
      // Quick-view popups mount a second product-info (a DIFFERENT product)
      // that publishes the same global variantChange event — only apply prices
      // attributable to this root's product.
      var rootPid = parseInt(root.getAttribute('data-product-id'), 10);
      if (!isNaN(rootPid) && productId !== rootPid) return;
      updateRoot(root, priceCents);
    });
  }

  function readPriceCentsForRoot(root) {
    // Scope all lookups to this root's own <product-info>: a quick-view popup
    // adds a second [data-selected-variant]/[data-product-price] for another
    // product, which must never feed this root.
    var scope = (root.closest && root.closest('product-info')) || document;
    var jsonEl = scope.querySelector('[data-selected-variant]');
    if (jsonEl) {
      try {
        var v = JSON.parse(jsonEl.textContent);
        if (v && typeof v.price === 'number') return v.price;
        if (v && typeof v.price === 'string') return Math.round(parseFloat(v.price) * 100);
        // Literal null = unavailable option combination. The theme hides the
        // price wrapper; keep the last shown value rather than falling back to
        // the stale page-load price.
        if (v === null) return null;
      } catch (e) {}
    } else {
      // No variant picker in scope (single-variant product): the server-rendered
      // cents are constant and correct. NOTE this attribute is written once at
      // page load (the snippet renders outside the #Price-* swap container), so
      // it must never be trusted after a variant change — unreachable here,
      // since a product with variants always renders [data-selected-variant].
      var cents = parseInt(root.getAttribute('data-price-cents'), 10);
      if (!isNaN(cents)) return cents;
    }
    // Last resort: parse the rendered price text within the same scope
    var el = scope.querySelector('[data-product-price]');
    if (el) return parsePriceString(el.textContent);
    return null;
  }

  function refresh() {
    document.querySelectorAll('[data-chiputt-per-month]').forEach(function (root) {
      updateRoot(root, readPriceCentsForRoot(root));
    });
  }

  function init() {
    if (!document.querySelector('[data-chiputt-per-month]')) return;
    refresh();

    // 1) Hook into the theme's pub-sub (Shaper/Symmetry-style theme)
    //    PUB_SUB_EVENTS.optionValueSelectionChange fires when a variant option changes
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.optionValueSelectionChange, function () {
        // Theme takes ~1 tick to fetch + update the price node — re-read shortly after
        setTimeout(refresh, 150);
        setTimeout(refresh, 600);
      });
      if (window.theme.PUB_SUB_EVENTS.variantChange) {
        // product-info publishes {data: {variant}} with price already in cents.
        // Apply directly only when the variant carries a product_id we can
        // attribute; otherwise fall back to a scoped refresh (always safe).
        window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
          var v = event && event.data && event.data.variant;
          if (v && typeof v.price === 'number' && typeof v.product_id === 'number') {
            updateAll(v.price, v.product_id);
            return;
          }
          setTimeout(refresh, 50);
        });
      }
    }

    // 2) MutationObserver on the price element — catches updates regardless of how the theme triggers them
    var priceEl = document.querySelector('[data-product-price]');
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(refresh).observe(priceEl, {
        childList: true,
        characterData: true,
        subtree: true,
      });
    }

    // 3) Fallback: native change event on the variant select (covers themes that re-render via form submit)
    document.addEventListener('change', function (evt) {
      if (evt.target.matches('select[name="id"], input[name="id"]')) {
        setTimeout(refresh, 150);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
